(function () {
  'use strict';

  var VERSION = '2026-07-16-pfb-xhr-v4';
  var storagePrefix = 'vpl_attr_';
  var fieldMap = {
    gclid: 'hidden-7',
    gbraid: 'hidden-4',
    wbraid: 'hidden-8',
    utm_source: 'hidden-3',
    utm_medium: 'hidden-2',
    utm_campaign: 'hidden-9',
    utm_term: 'hidden-6',
    utm_content: 'hidden-5',
    landing_page: 'hidden-1'
  };
  var adKeys = ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var extraCaptureKeys = ['gad_source', 'campaignid', 'adgroupid', 'creative', 'device', 'network', 'gad_campaignid', 'gad_adgroupid', 'gad_keyword', 'gad_matchtype', 'msclkid'];

  window.VPL_ATTRIBUTION_BRIDGE_VERSION = VERSION;

  function normalise(value) { return String(value || '').trim().toLowerCase().replace(/[\s-]+/g, '_'); }
  function readStorage(key) { try { return window.localStorage.getItem(storagePrefix + key) || ''; } catch (e) { return ''; } }
  function writeStorage(key, value) { if (!value) return; try { window.localStorage.setItem(storagePrefix + key, value); } catch (e) {} }

  function captureUrlParams() {
    var params = new URLSearchParams(window.location.search);
    adKeys.concat(extraCaptureKeys).forEach(function (key) { writeStorage(key, params.get(key)); });
    if (!readStorage('landing_page')) writeStorage('landing_page', window.location.href);
    writeStorage('last_seen_page', window.location.href);
  }

  function getValue(key) { return key === 'landing_page' ? readStorage(key) || window.location.href : readStorage(key); }

  function attributionByHiddenId() {
    var out = {};
    Object.keys(fieldMap).forEach(function (key) {
      var value = getValue(key);
      if (value) out[fieldMap[key]] = value;
    });
    return out;
  }

  function attributionByName() {
    var out = {};
    Object.keys(fieldMap).forEach(function (key) {
      var value = getValue(key);
      if (value) out[key] = value;
    });
    return out;
  }

  function labelMapAdditions() {
    var out = {};
    Object.keys(fieldMap).forEach(function (key) {
      out[fieldMap[key]] = key;
      out[key] = key;
    });
    return out;
  }

  function attrEqualsSelector(name) {
    return String(name || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function setInputValue(input, value) {
    if (!input || !value) return;
    input.value = value;
    input.defaultValue = value;
    input.setAttribute('value', value);
    input.setAttribute('data-default-value', value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function ensureHiddenInput(form, name, value, id) {
    if (!form || !name || !value) return;
    var selector = 'input[name="' + attrEqualsSelector(name) + '"]';
    var input = form.querySelector(selector);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.id = id || name;
      input.setAttribute('data-vpl-attribution', 'true');
      form.appendChild(input);
    }
    setInputValue(input, value);
  }

  function updateKeyLabel(form) {
    if (!form) return;
    var input = form.querySelector('input[name="_keyLabel"]');
    if (!input) return;
    var labels = {};
    try { labels = input.value ? JSON.parse(input.value) : {}; } catch (e) { labels = {}; }
    var additions = labelMapAdditions();
    Object.keys(additions).forEach(function (key) { labels[key] = additions[key]; });
    input.value = JSON.stringify(labels);
  }

  function setByKnownId(key, value) {
    var id = fieldMap[key];
    if (!id || !value) return;
    document.querySelectorAll('#' + id + ', input[name="' + id + '"]').forEach(function (input) { setInputValue(input, value); });
  }

  function setByPfbLabel(key, value) {
    if (!value) return;
    document.querySelectorAll('.globo-form-control[data-type="hidden"], .globo-form-control[data-element-id^="hidden-"]').forEach(function (wrap) {
      var labelEl = wrap.querySelector('[data-label]');
      if (normalise(labelEl && labelEl.getAttribute('data-label')) === key) {
        setInputValue(wrap.querySelector('input[type="hidden"]'), value);
      }
    });
  }

  function findKeyForPfbElement(element) {
    if (!element) return '';
    var id = normalise(element.id);
    var label = normalise(element.label && (element.label.en || element.label));
    var keys = Object.keys(fieldMap);
    for (var i = 0; i < keys.length; i++) if (fieldMap[keys[i]] === id || label === keys[i]) return keys[i];
    return '';
  }

  function patchGloboElement(element) {
    if (!element || typeof element !== 'object') return;
    var key = findKeyForPfbElement(element);
    var value = key && getValue(key);
    if (value) {
      element.dataType = 'fixed';
      element.fixedValue = value;
      element.defaultValue = value;
      element.value = value;
      element.dynamicValue = [];
    }
    if (Array.isArray(element.elements)) element.elements.forEach(patchGloboElement);
  }

  function patchGloboConfig() {
    var forms = window.Globo && window.Globo.FormBuilder && window.Globo.FormBuilder.forms;
    if (!forms) return;
    Object.keys(forms).forEach(function (id) {
      var formConfig = forms[id];
      if (formConfig && Array.isArray(formConfig.elements)) formConfig.elements.forEach(patchGloboElement);
    });
  }

  function injectPfbFormFields(form) {
    if (!form) return;
    var byId = attributionByHiddenId();
    var byName = attributionByName();
    Object.keys(byId).forEach(function (id) { ensureHiddenInput(form, id, byId[id]); });
    Object.keys(byName).forEach(function (key) { ensureHiddenInput(form, key, byName[key], 'vpl_attr_' + key); });
    updateKeyLabel(form);
  }

  function fillAttributionFields() {
    captureUrlParams();
    patchGloboConfig();
    Object.keys(fieldMap).forEach(function (key) {
      var value = getValue(key);
      setByKnownId(key, value);
      setByPfbLabel(key, value);
    });
    document.querySelectorAll('form[action*="powerfulform"], form[action*="globo"], .globo-form-app form').forEach(injectPfbFormFields);
  }

  function enrichFormData(formData) {
    var byId = attributionByHiddenId();
    var byName = attributionByName();
    Object.keys(byId).forEach(function (key) { formData.set(key, byId[key]); });
    Object.keys(byName).forEach(function (key) { formData.set(key, byName[key]); });
    var labels = {};
    try { labels = formData.get('_keyLabel') ? JSON.parse(formData.get('_keyLabel')) : {}; } catch (e) { labels = {}; }
    var additions = labelMapAdditions();
    Object.keys(additions).forEach(function (key) { labels[key] = additions[key]; });
    formData.set('_keyLabel', JSON.stringify(labels));
    return formData;
  }

  function mutateObject(value) {
    if (!value || typeof value !== 'object') return false;
    var changed = false;
    var byId = attributionByHiddenId();
    var byName = attributionByName();
    if (Array.isArray(value)) { value.forEach(function (item) { if (mutateObject(item)) changed = true; }); return changed; }
    var id = value.id || value.name || value.key || value.field || value.element_id || value.elementId;
    var normalId = normalise(id);
    var keyFromLabel = normalise(value.label && (value.label.en || value.label));
    Object.keys(byId).forEach(function (hiddenId) {
      var attrKey = Object.keys(fieldMap).find(function (key) { return fieldMap[key] === hiddenId; });
      var attrValue = byId[hiddenId];
      if (normalId === normalise(hiddenId) || keyFromLabel === normalise(attrKey)) {
        value.value = attrValue;
        value.fixedValue = attrValue;
        value.defaultValue = attrValue;
        value.dataType = 'fixed';
        changed = true;
      }
    });
    Object.keys(value).forEach(function (key) {
      if (byId[key]) { value[key] = byId[key]; changed = true; }
      if (byName[key]) { value[key] = byName[key]; changed = true; }
      if (value[key] && typeof value[key] === 'object' && mutateObject(value[key])) changed = true;
    });
    return changed;
  }

  function enrichBody(body) {
    fillAttributionFields();
    if (!body) return body;
    if (window.FormData && body instanceof FormData) return enrichFormData(body);
    if (window.URLSearchParams && body instanceof URLSearchParams) {
      var byName = attributionByName();
      Object.keys(byName).forEach(function (key) { body.set(key, byName[key]); });
      Object.keys(attributionByHiddenId()).forEach(function (key) { body.set(key, attributionByHiddenId()[key]); });
      return body;
    }
    if (typeof body === 'string') {
      try {
        var parsed = JSON.parse(body);
        var changed = mutateObject(parsed);
        if (parsed && typeof parsed === 'object') { parsed.vpl_attribution = Object.assign({}, attributionByName(), attributionByHiddenId()); changed = true; }
        if (changed) return JSON.stringify(parsed);
      } catch (jsonError) {}
      if (body.indexOf('=') !== -1) {
        try {
          var params = new URLSearchParams(body);
          Object.keys(attributionByName()).forEach(function (key) { params.set(key, attributionByName()[key]); });
          Object.keys(attributionByHiddenId()).forEach(function (key) { params.set(key, attributionByHiddenId()[key]); });
          return params.toString();
        } catch (paramsError) {}
      }
    }
    return body;
  }

  function isPfbUrl(url) { return /powerfulform|globo\.io|globosoftware|api\/front\/form/i.test(String(url || '')); }

  function installNetworkHooks() {
    if (window.VPL_ATTRIBUTION_NETWORK_HOOKED) return;
    window.VPL_ATTRIBUTION_NETWORK_HOOKED = true;
    if (window.fetch) {
      var originalFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : input && input.url;
        if (isPfbUrl(url) && init && init.body) init.body = enrichBody(init.body);
        return originalFetch.apply(this, arguments);
      };
    }
    if (window.XMLHttpRequest) {
      var originalOpen = XMLHttpRequest.prototype.open;
      var originalSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) { this.__vplAttributionUrl = url; return originalOpen.apply(this, arguments); };
      XMLHttpRequest.prototype.send = function (body) { if (isPfbUrl(this.__vplAttributionUrl)) body = enrichBody(body); return originalSend.call(this, body); };
    }
  }

  function installGloboXhrPatch() {
    var builder = window.Globo && window.Globo.FormBuilder;
    if (!builder || typeof builder.xhr !== 'function' || builder.__vplAttributionXhrPatched) return false;
    var originalXhr = builder.xhr;
    builder.xhr = function (form) {
      fillAttributionFields();
      injectPfbFormFields(form);
      return originalXhr.apply(this, arguments);
    };
    builder.__vplAttributionXhrPatched = true;
    return true;
  }

  function installSubmitHooks() {
    document.addEventListener('submit', function () { fillAttributionFields(); installGloboXhrPatch(); }, true);
    ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (eventName) {
      document.addEventListener(eventName, function () { fillAttributionFields(); installGloboXhrPatch(); }, true);
    });
  }

  captureUrlParams();
  installNetworkHooks();
  installSubmitHooks();
  fillAttributionFields();
  installGloboXhrPatch();
  [100, 250, 750, 1500, 3000, 6000, 10000, 15000].forEach(function (delay) {
    window.setTimeout(function () { fillAttributionFields(); installGloboXhrPatch(); }, delay);
  });
  document.addEventListener('globo.formbuilder.scripts.loaded', function () { fillAttributionFields(); installGloboXhrPatch(); }, true);
  if (window.MutationObserver) new MutationObserver(function () { fillAttributionFields(); installGloboXhrPatch(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
